import { render, staticRenderFns } from "./EditCourt.vue?vue&type=template&id=36e17aba"
import script from "./EditCourt.vue?vue&type=script&lang=js"
export * from "./EditCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports